module.exports = __webpack_public_path__ + "assets/img/back-5.4df7b17c.png";